import * as _ from 'lodash';
import moment from 'moment';

export const chartHelper = (array) => {
  const reg = /^\d*\.?\d*$/;

  return {
    dateFormatChange : (format) => {
      if(!reg.test(array[0]) && _.isDate(new Date(array[0])) && moment(array[0]).isValid()){
        return array.map((value) => moment(value).format(format))
      }else if(reg.test(array[0])){
        return array.map((value) => Number(Number(value).toFixed(2)))
      }
      return array;
    },

    numberFormat : (decimal) => {
      if(reg.test(array[0])){
        /* null passes through as null. `Number(null)` is 0, so a point a period never
           reported was being rounded into a real zero here - the last place it could
           have survived as "no figure". A comparison relies on the difference; an
           ordinary chart has no nulls to begin with, so nothing else changes. */
        return array.map((value) =>
          value === null || value === undefined ? null : Number(Number(value).toFixed(decimal))
        )
      }
      return array;
    }
  }
  
};